<template>
  <div class="page-contact tier tier-three">
    <div class="tier-content">
      <Tooltip content="Add and edit your contact details here"/>

      <Notification
        v-if="notification.active"
        :content="notification.content"
        :type="notification.type"/>

      <PageHeader>
        <div class="heading">
          <h1>
            <strong class="name">Contact</strong>
          </h1>
        </div>
        <Btn secondary @click="activateConfirm">
          <Sprite name="bin"/>
        </Btn>
      </PageHeader>

      <div class="site-contact">
        <contact-form
          v-model="contact"
          :showOptions="false"
          :isSocial="contact.type === 'social'"
          @submit="submitContact"
          :contactType="contact.type"
          :contactKey="contact.key">
        </contact-form>
      </div>

      <Confirm
        v-if="confirmActive"
        @confirm="deleteContact"
        @cancel="cancel"
        :message="deleteMessage"
        :link="{
          name: 'contact',
          params: {companyId: companyId, siteId: siteId, contactId: contactId}}"/>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'
import confirm from '@/mixins/confirm'
import notification from '@/mixins/notification'

import {readCompanySiteData} from '@/lib/sites'
import {
  readCompanySiteContactData,
  deleteCompanySiteContactData,
  updateCompanySiteContactData
} from '@/lib/contacts'

import ContactForm from '@/components/forms/ContactForm'
import PageHeader from '@/components/PageHeader'
import Btn from '@/components/Btn'
import Sprite from '@/components/Sprite'
import Tooltip from '@/components/Tooltip'

export default {
  name: 'Contact',

  props: {
    companyId: {
      type: String,
      required: true
    },

    siteId: {
      type: String,
      required: true
    },

    contactId: {
      type: String,
      required: true
    }
  },

  mixins: [page, pagination, confirm, notification],

  components: {
    PageHeader,
    Btn,
    Sprite,
    Tooltip,
    ContactForm
  },

  data() {
    return {
      site: {},
      contact: {},
      errors: {},
      typeOptions: [
        {
          key: 'Social Platform',
          value: 'social'
        },
        {
          key: 'Phone Number',
          value: 'phone'
        },
        {
          key: 'Email Address',
          value: 'email'
        },
        {
          key: 'Address',
          value: 'address'
        }
      ]
    }
  },

  methods: {
    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(
        ({data}) => {
          this.site = data
        }
      )

      readCompanySiteContactData(this.companyId, this.siteId, this.contactId).then(
        ({data}) => {
          this.contact = data
        }
      )
    },

    submitContact() {
      updateCompanySiteContactData(
        this.companyId,
        this.siteId,
        this.contactId,
        this.contact
      ).then(({data}) => {
        this.$emit('updatePage')
        this.triggerNotification('success', 'Contact', 'updated')
      })
    },

    deleteContact() {
      deleteCompanySiteContactData(this.companyId, this.siteId, this.contactId).then(
        () => {
          this.$emit('updatePage')
          this.confirmActive = false
          this.triggerNotification('success', 'Contact', 'deleted')

          window.setTimeout(() => {
            this.$router.push({
              name: 'contact-settings',
              params: {companyId: this.companyId, siteId: this.siteId}
            })
          }, this.closeDelay)
        }
      )
    }
  },

  computed: {
    title() {
      return `Editing ${this.contact.type} settings (${this.contact.value})`
    },

    deleteMessage() {
      return `Are you sure you wish to delete this contact method?`
    },

    updatedNotification() {
      return {
        type: 'success',
        content: `Contact method updated!`
      }
    },

    deletedNotification() {
      return {
        type: 'success',
        content: `Contact method deleted!`
      }
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.page-contact
.image-preview
  max-width: 300px
</style>
